import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { SharedService } from '../../../../../shared/sharedServices/shared.service';
import { NgForm } from '@angular/forms';
import { CommonHelper } from '../../../../../utilities/common.helper';
import { ProfileComponent } from '../../profile.component';
import { HecResponse } from '../../../../../shared/shared-interfaces/hecResponse';
import { HEC_CONSTANTS } from '../../../../../utilities/constants';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';
import { LoaderService } from '../../../../../shared/sharedServices/loader.service';

@Component({
	selector: 'kt-change-phonenumber',
	templateUrl: './change-phonenumber.component.html',
	styleUrls: ['./change-phonenumber.component.scss']
})
export class ChangePhonenumberComponent implements OnInit {
	@ViewChild('updatePhoneForm', { static: false }) updatePhoneForm: NgForm;
	public sendCode: boolean = false;
	public timer;
	public phone_number:any;
	public userCellNumber: any;
	public userCountryCode: any
	public resendCodeSeconds: boolean = false;
	public countryCode: any;
	public countriesDialingCodes: Array<any>;
	public isAlertVisible: boolean = false;
	public alertType: string;
	public alertIcon: string;
	public dialingCode:any;
	public alertMsgValue: string;
	separateDialCode = true;
	SearchCountryField = SearchCountryField;
	TooltipLabel = TooltipLabel;
	CountryISO = CountryISO;
	@ViewChild('seconds', { static: false }) elementView: ElementRef;
	constructor(private sharedServices: SharedService, private cdr: ChangeDetectorRef, private profileComp: ProfileComponent,
		private loaderService:LoaderService) { }

	ngOnInit() {
		this.getCountriesDialingCodes();
		window.scroll(0,0)
	}

	public async submitUserRequest() {
		this.isAlertVisible = false;
		await this.getSelectedCountry();
		this.markFormsTouched(this.updatePhoneForm)
		if (this.validate(this.updatePhoneForm.form.controls.cell)) {
			this.loaderService.setValue(true)
			let payload = {
				data: {
					contactValue: this.userCellNumber,
					countryId: this.countryCode,
					verificationTypeId: 703105,
					checkEmail: false,
				}
			}
			this.sharedServices.postSendMobileVerificationCode(payload).subscribe(
				(res: HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						if (res.data == true) {
							this.isAlertVisible = true;
							this.resendCodeSeconds = false;
							this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.UPDATE_PHONE_REQ;
							this.alertType = HEC_CONSTANTS.ERROR_TYPES.success;
							// this.profileComp.loader = false;
							this.loaderService.setValue(false)
							this.sendCode = true
							this.cdr.detectChanges();
							this.InitTimer();
							this.getTimer();

						}
					} else if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.ALREADY_EXIST) {
						this.isAlertVisible = true;
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.ALREADY_EXISTS_PHONE;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						// this.profileComp.loader = false;
						this.loaderService.setValue(false)
						this.cdr.detectChanges();
					}
					else {
						this.isAlertVisible = true;
						this.alertMsgValue = res.statusDescription;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						// this.profileComp.loader = false;
						this.loaderService.setValue(false)
						this.cdr.detectChanges();
						this.cdr.markForCheck();
					}
				},
				(err) => {
					this.isAlertVisible = true;
					this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.SOMETHING_ERROR;
					this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
					// this.profileComp.loader = false;
					this.loaderService.setValue(false)
					this.cdr.detectChanges();
				}
			)
		}
	}

	public updateEmailAddress() {
		this.isAlertVisible = false;
		this.markFormsTouched(this.updatePhoneForm)
		if (this.validate(this.updatePhoneForm.form.controls.emailCode)) {
			// this.profileComp.loader = true;
			this.loaderService.setValue(true)
			let payload = {
				data: {
					contactValue: this.userCellNumber,
					code: Number(this.updatePhoneForm.value.emailCode),
					verificationTypeId: "703105",
					countryId: this.countryCode
				}
			}
			this.sharedServices.updatePrimaryCellNumber(payload).subscribe(
				async (res:HecResponse) => {
					if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
						await this.profileComp.getUserPersonalDetails();
						this.sendCode = false
						this.isAlertVisible = true;
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.PHONE_UPDATE_SUCCESS;
						this.alertType =  HEC_CONSTANTS.ERROR_TYPES.success;
						// this.profileComp.loader = false;
						this.loaderService.setValue(false)
						this.profileComp.getUserContactDetails();
						this.timer = new Date();
						if (this.elementView != undefined) {
							this.elementView.nativeElement.innerText = 0;
						}
						this.resendCodeSeconds = true;
						this.updatePhoneForm.reset();
						this.cdr.detectChanges();
						setTimeout(()=>{
							this.isAlertVisible = false;
							this.cdr.detectChanges()
								},2000)
					} else if (res.statusCode == 300) {
						this.alertMsgValue = HEC_CONSTANTS.ERROR_MESSGAES.profileMessages.AUTHENTICATION_CODE_INVALID;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.isAlertVisible = true;
						// this.profileComp.loader = false;
						this.loaderService.setValue(false)
						this.cdr.detectChanges();
					}else{
						this.alertMsgValue = res.statusDescription;
						this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
						this.isAlertVisible = true;
						// this.profileComp.loader = false;
						this.loaderService.setValue(false)
						this.cdr.detectChanges();

					}
				})
		}
	}

	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public validate(f): boolean {
		if (f.status === 'VALID') {
			return true;
		}
	}

	public cancelChange(): void {
		this.isAlertVisible = false;
		this.timer = new Date();
		if (this.elementView != undefined) {
			this.elementView.nativeElement.innerText = 0;
			this.resendCodeSeconds = true;
			this.cdr.detectChanges();

		}
		this.sendCode = false;
		this.cdr.detectChanges();
	}

	public getSelectedCountry() {
		// this.profileComp.loader = true;
		this.loaderService.setValue(true)
		return new Promise((resolve, reject) => {
		if(this.updatePhoneForm.form.controls.cell.status == 'VALID'){
			this.dialingCode = this.updatePhoneForm.form.controls.cell.value.dialCode;
			let countryCode = this.updatePhoneForm.form.controls.cell.value.countryCode;
			this.userCellNumber= this.updatePhoneForm.form.controls.cell.value.number.replace(/[^A-Z0-9]/ig,"");
		this.sharedServices.getCountryByDialingCode(this.dialingCode,countryCode).subscribe(
			(res:HecResponse) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK && res.data != undefined) {
					this.countryCode = res.data.value;
					resolve(this.countryCode)
					this.cdr.detectChanges();

				}
			}
		)
		}
	})
	}

	public getCountriesDialingCodes(): any {
		return new Promise((resolve, reject) => {
			this.sharedServices.getCountriesDialingCode().subscribe(
				(res) => {
					this.countriesDialingCodes = res.data;
					resolve(this.countriesDialingCodes);
				}
			)
		})
			.catch(function (error) {
			})
	}

	public getTimer() {
		if (this.resendCodeSeconds == false) {
			setInterval(() => {
				if (this.resendCodeSeconds == false) {
					if (Number(this.elementView.nativeElement.innerText) > 0) {
						if (Number(this.elementView.nativeElement.innerText) == 1) {
							this.resendCodeSeconds = true;
							this.cdr.detectChanges();
						}
					}
				}
			}, 1000)
		}
		setTimeout(() => {
			this.InitTimer();
		}, 500)
	}


	public InitTimer() {
		this.timer = new Date();
		this.timer.setMinutes(this.timer.getMinutes() + 1);
		function getTimeRemaining(endtime) {
			endtime = new Date(endtime);
			let t = 0;
			let seconds = 0;
			if (endtime > new Date()) {
				t = endtime.getTime() - new Date().getTime();
				seconds = Math.floor((t / 1000) % 60);
			}
			return {
				'total': t,
				'seconds': seconds,
			};
		}

		function initializeClock(id, endtime) {
			const clock = document.getElementById(id);
			const secondsSpan = clock.querySelector('.seconds');

			function updateClock() {
				const t = getTimeRemaining(endtime);
				secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
				if (t.total <= 0) {
					clearInterval(timeinterval);
				}
			}

			updateClock();
			const timeinterval = setInterval(updateClock, 1000);
		}

		initializeClock('clockdiv', this.timer);
	}


}
